import React from "react";
import { motion } from "framer-motion";
import {
  FaChalkboardTeacher,
  FaBookReader,
  FaGraduationCap,
  FaUserCheck,
  FaLightbulb,
} from "react-icons/fa";
import img1 from "../../assets/grp pic.png";
import img2 from "../../assets/DSC_2876_JPG.png";
import img3 from "../../assets/NTT Teachers indiranagar.png";
import "./TransformSection.css";

const features = [
  {
    icon: <FaBookReader />,
    text: "Get trained in both Theory & Practicals.",
  },
  {
    icon: <FaLightbulb />,
    text: "Value Added Programs (VAPs) to develop your soft skills.",
  },
  {
    icon: <FaChalkboardTeacher />,
    text: "Dynamic curriculum that adapts to modern school environments.",
  },
  {
    icon: <FaGraduationCap />,
    text: "Stay relevant with the latest teaching methodologies & techniques.",
  },
  {
    icon: <FaUserCheck />,
    text: "Get complete placement support after your training.",
  },
];

const TransformSection = () => {
  return (
    <section className="transform-section">
      <div className="transform-container">
        {/* Heading */}
        <motion.h2
          className="transform-heading"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Transform Yourself into a <span>Best Teacher!</span>
        </motion.h2>

        {/* Image Grid */}
        <div className="transform-images">
          <motion.img
            src={img1}
            alt="NIECCE Training"
            className="image-item"
            whileHover={{ scale: 1.05 }}
          />
          <motion.img
            src={img2}
            alt="NIECCE Students"
            className="image-item"
            whileHover={{ scale: 1.05 }}
          />
          <motion.img
            src={img3}
            alt="NIECCE Teachers"
            className="image-item large"
            whileHover={{ scale: 1.05 }}
          />
        </div>

        {/* Features List */}
        <motion.ul
          className="transform-features"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          {features.map((feature, i) => (
            <motion.li
              key={i}
              className="feature-item"
              initial={{ x: -40, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ delay: i * 0.2 }}
            >
              <span className="icon">{feature.icon}</span>
              <p>{feature.text}</p>
            </motion.li>
          ))}
        </motion.ul>
      </div>
    </section>
  );
};

export default TransformSection;
